import { IconArrowRight } from '@tabler/icons-react'
import { motion } from 'framer-motion';
import { container } from './../../pages/homepage/Section1';
import { Link } from 'react-router-dom';
import { useState } from 'react';

const Section1 = ({datas}) => {
    const [isActive, setIsActive] = useState(false);
    const [seed, setSeed] = useState(1);
    const reset = () => {
        setSeed(Math.random());
    }
    const handleClick = event => {
        setIsActive(current => !current);
        reset()
    }

  return (
    <div className='s1-container fin-reco-container vadr'>
        <div className='bg-grid'>
            <div className='f-width m-auto'>
                <div className='row'>
                    <div className='col-lg-6 col-sm-12'>
                        <motion.div variants={container} whileInView="visible" initial="hidden" className='hero-data text-start'>
                            <p className='fs-lg text-white'>{datas.heading}</p>
                            <p className='fs-sm txt-offwhite'>{datas.subText}</p>
                            <Link to={datas.btnLink}><div className='btn brand-bg text-white rounded-pill shadow'>{datas.btnText} <IconArrowRight className='btn-arr' /></div></Link>
                        </motion.div>
                    </div>
                    <div className='col-lg-6 col-sm-12 hero-img-vid'>
                        <div className='s1v1-youtube'>
                            <div className='ytubee' key={seed}>
                                {
                                    datas.ytVideoID === "no_vid" ?
                                        <img className='yt-thumb' src={datas.thumbnail} alt='youtube_thumbnail' /> :
                                        <>
                                        <div className={isActive ? 'd-none' : 'yt_section'}>
                                            <img className='yt-thumb' src={datas.thumbnail} alt='youtube_thumbnail' />
                                            <div className='d-flex thumb-text-btn align-items-end' onClick={handleClick} data-toggle="tooltip" title="Play">
                                                <p className="left-bottom mb-1">{datas.thumbText}</p>
                                                <div className='playBtnWrap'>
                                                    <img src={datas.playBtn} className='play_btn' alt='play_button' />
                                                </div>
                                            </div>
                                        </div>
                                        <iframe className={isActive ? 'video_frame' : 'd-none'} src={`https://www.youtube.com/embed/${datas.ytVideoID}${isActive ? "?autoplay=1" : ""}`} title="Voosh: All In 1 Restaurant Dashboard for Delivery Financials, Reputation Management, and Operations!" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowFullScreen></iframe>
                                        </>
                                }
                                
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Section1